import React from 'react';

const TextareaInput = ({ question, value, onChange, error }) => {
  return (
    <div className="question-input">
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={question.placeholder}
        className={`quiz-textarea ${error ? 'error' : ''}`}
        rows="4"
        required={question.required}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default TextareaInput;